import GeneralForm from './../Forms/GeneralForm';

const BrandsInWorkWithUsePageBuilder = {
    component: GeneralForm,
    options: {
        columns: {
            contents: [
                {
                    field: "brands",
                    partial: {
                        handler: (props) => {
                            return props.formHandler.buildArrayInputs("contents", "brands", "برندها")
                        },
                    }
                }
            ]
        }
    }
};

export default BrandsInWorkWithUsePageBuilder





// WEBPACK FOOTER //
// ./src/containers/Pages/Builders/BrandsInWorkWithUsePageBuilder.js